import React from "react";
import {
  MetricRow,
  SNAPSHOT_CARD_STYLE,
  SNAPSHOT_CARD_TITLE_STYLE,
} from "../dashboard/SnapshotMetricCard";
import "../dashboard/dashboardWidget.css";

function formatMoney(amount) {
  return `$${Number(amount || 0).toFixed(2)}`;
}

function MoneyValue({ amount, emphasized = false }) {
  return (
    <span
      style={{
        minWidth: "72px",
        flexShrink: 0,
        textAlign: "right",
        fontSize: emphasized ? "18px" : "16px",
        fontWeight: 800,
        color: "#4ee2a1",
      }}
    >
      {formatMoney(amount)}
    </span>
  );
}

export function AccountsReceivableDashboard({
  metrics,
  loading,
  className = "",
}) {
  if (loading) {
    return (
      <p className={className || undefined} style={{ opacity: 0.7 }}>
        Loading receivables…
      </p>
    );
  }

  const aging = metrics?.aging || {};

  return (
    <div
      className={["ar-dashboard", className].filter(Boolean).join(" ")}
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "14px",
        marginBottom: "18px",
      }}
    >
      <div
        style={SNAPSHOT_CARD_STYLE}
        className="ar-dashboard__card kpi-snapshot-card dashboard-widget-card"
      >
        <div className="dashboard-widget-title" style={SNAPSHOT_CARD_TITLE_STYLE}>
          Outstanding Receivables
        </div>
        <MetricRow
          label="Total Open"
          valueNode={
            <MoneyValue
              amount={metrics?.outstandingReceivables}
              emphasized
            />
          }
        />
        <MetricRow
          label="Current"
          valueNode={<MoneyValue amount={aging.current} />}
        />
        <MetricRow
          label="1–30"
          valueNode={<MoneyValue amount={aging.days_30} />}
        />
        <MetricRow
          label="31–60"
          valueNode={<MoneyValue amount={aging.days_60} />}
        />
        <MetricRow
          label="61–90"
          valueNode={<MoneyValue amount={aging.days_90} />}
        />
        <MetricRow
          label="90+"
          valueNode={<MoneyValue amount={aging.days_90_plus} />}
        />
      </div>

      <div
        style={SNAPSHOT_CARD_STYLE}
        className="ar-dashboard__card kpi-snapshot-card dashboard-widget-card"
      >
        <div className="dashboard-widget-title" style={SNAPSHOT_CARD_TITLE_STYLE}>
          Collections Snapshot
        </div>
        <MetricRow
          label="Paid This Month"
          valueNode={<MoneyValue amount={metrics?.paidThisMonth} />}
        />
        <MetricRow label="Open Invoices" value={metrics?.invoiceCount ?? 0} />
        <MetricRow
          label="Customers With Balance"
          value={metrics?.customerCount ?? 0}
        />
      </div>
    </div>
  );
}
